import { NgModule} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { SharedModule } from "../../../components/shared/shared.module";

// ------------------------------------------Start Service----------------------------------------------------------------------//
import { BsDropdownModule, CollapseModule, ModalModule } from "ngx-bootstrap";
import { InterceptorService } from "../../../service/components/authentication/interceptor.service";
import { UserManageService } from "../../../service/api/jubili/user-manage.service";
import { Ng2SmartTableModule } from "ng2-smart-table";
import { PoItemTableComponent } from "./po-item-table/po-item-table.component";
import { PoItemDetailComponent } from "./po-item-detail/po-item-detail.component";
import { PipeModule } from "../../../pipe/pipe.module";
import { BuilkSharedModule } from "../shared/shared.module";
import { LoadingModule } from "ngx-loading";
// ------------------------------------------End Service----------------------------------------------------------------------//

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        BrowserModule,
        RouterModule,
        SharedModule,
        BsDropdownModule.forRoot(),
        CollapseModule.forRoot(),
        ModalModule.forRoot(),
        Ng2SmartTableModule,
        PipeModule,
        BuilkSharedModule,
        LoadingModule
    ],
    declarations: [
        PoItemTableComponent,
        PoItemDetailComponent
    ],
    exports: [
        SharedModule,
        Ng2SmartTableModule,
        PoItemTableComponent,
        PoItemDetailComponent
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        UserManageService
    ]
})

export class PoItemModule { }
